import _isNil from "lodash/isNil.js";
function cov_2cjzfzrvji() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountPasswordForm.tsx";
  var hash = "9807a44693d66588362b0ed9f763b4b2a7a2dcc8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/AccountPasswordForm.tsx",
    statementMap: {
      "0": {
        start: {
          line: 55,
          column: 28
        },
        end: {
          line: 376,
          column: 1
        }
      },
      "1": {
        start: {
          line: 85,
          column: 20
        },
        end: {
          line: 85,
          column: 54
        }
      },
      "2": {
        start: {
          line: 87,
          column: 36
        },
        end: {
          line: 87,
          column: 60
        }
      },
      "3": {
        start: {
          line: 88,
          column: 28
        },
        end: {
          line: 88,
          column: 63
        }
      },
      "4": {
        start: {
          line: 89,
          column: 41
        },
        end: {
          line: 89,
          column: 65
        }
      },
      "5": {
        start: {
          line: 90,
          column: 52
        },
        end: {
          line: 90,
          column: 76
        }
      },
      "6": {
        start: {
          line: 91,
          column: 30
        },
        end: {
          line: 91,
          column: 66
        }
      },
      "7": {
        start: {
          line: 92,
          column: 46
        },
        end: {
          line: 92,
          column: 70
        }
      },
      "8": {
        start: {
          line: 93,
          column: 43
        },
        end: {
          line: 93,
          column: 87
        }
      },
      "9": {
        start: {
          line: 94,
          column: 36
        },
        end: {
          line: 94,
          column: 56
        }
      },
      "10": {
        start: {
          line: 95,
          column: 40
        },
        end: {
          line: 99,
          column: 10
        }
      },
      "11": {
        start: {
          line: 101,
          column: 26
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "12": {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 105,
          column: 9
        }
      },
      "13": {
        start: {
          line: 104,
          column: 10
        },
        end: {
          line: 104,
          column: 71
        }
      },
      "14": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 112,
          column: 10
        }
      },
      "15": {
        start: {
          line: 117,
          column: 32
        },
        end: {
          line: 128,
          column: 37
        }
      },
      "16": {
        start: {
          line: 118,
          column: 18
        },
        end: {
          line: 118,
          column: 47
        }
      },
      "17": {
        start: {
          line: 119,
          column: 21
        },
        end: {
          line: 119,
          column: 58
        }
      },
      "18": {
        start: {
          line: 120,
          column: 26
        },
        end: {
          line: 120,
          column: 67
        }
      },
      "19": {
        start: {
          line: 121,
          column: 34
        },
        end: {
          line: 121,
          column: 60
        }
      },
      "20": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 127,
          column: 7
        }
      },
      "21": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 36
        }
      },
      "22": {
        start: {
          line: 125,
          column: 8
        },
        end: {
          line: 125,
          column: 40
        }
      },
      "23": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 32
        }
      },
      "24": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 135,
          column: 39
        }
      },
      "25": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 131,
          column: 28
        }
      },
      "26": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 134,
          column: 7
        }
      },
      "27": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 37
        }
      },
      "28": {
        start: {
          line: 137,
          column: 35
        },
        end: {
          line: 137,
          column: 95
        }
      },
      "29": {
        start: {
          line: 137,
          column: 49
        },
        end: {
          line: 137,
          column: 95
        }
      },
      "30": {
        start: {
          line: 139,
          column: 57
        },
        end: {
          line: 149,
          column: 5
        }
      },
      "31": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 20
        }
      },
      "32": {
        start: {
          line: 141,
          column: 26
        },
        end: {
          line: 141,
          column: 52
        }
      },
      "33": {
        start: {
          line: 142,
          column: 26
        },
        end: {
          line: 142,
          column: 44
        }
      },
      "34": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "35": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 145,
          column: 57
        }
      },
      "36": {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 147,
          column: 50
        }
      },
      "37": {
        start: {
          line: 151,
          column: 58
        },
        end: {
          line: 156,
          column: 5
        }
      },
      "38": {
        start: {
          line: 152,
          column: 34
        },
        end: {
          line: 152,
          column: 54
        }
      },
      "39": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 22
        }
      },
      "40": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 30
        }
      },
      "41": {
        start: {
          line: 158,
          column: 61
        },
        end: {
          line: 165,
          column: 5
        }
      },
      "42": {
        start: {
          line: 160,
          column: 6
        },
        end: {
          line: 160,
          column: 33
        }
      },
      "43": {
        start: {
          line: 163,
          column: 6
        },
        end: {
          line: 163,
          column: 72
        }
      },
      "44": {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 164,
          column: 28
        }
      },
      "45": {
        start: {
          line: 167,
          column: 25
        },
        end: {
          line: 200,
          column: 5
        }
      },
      "46": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 25
        }
      },
      "47": {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 172,
          column: 7
        }
      },
      "48": {
        start: {
          line: 171,
          column: 8
        },
        end: {
          line: 171,
          column: 15
        }
      },
      "49": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 182,
          column: 7
        }
      },
      "50": {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 15
        }
      },
      "51": {
        start: {
          line: 184,
          column: 6
        },
        end: {
          line: 193,
          column: 7
        }
      },
      "52": {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 190,
          column: 9
        }
      },
      "53": {
        start: {
          line: 186,
          column: 10
        },
        end: {
          line: 186,
          column: 62
        }
      },
      "54": {
        start: {
          line: 189,
          column: 10
        },
        end: {
          line: 189,
          column: 44
        }
      },
      "55": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 26
        }
      },
      "56": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 199,
          column: 9
        }
      },
      "57": {
        start: {
          line: 203,
          column: 6
        },
        end: {
          line: 205,
          column: 87
        }
      },
      "58": {
        start: {
          line: 207,
          column: 21
        },
        end: {
          line: 207,
          column: 33
        }
      },
      "59": {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 212,
          column: 5
        }
      },
      "60": {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 29
        }
      },
      "61": {
        start: {
          line: 210,
          column: 11
        },
        end: {
          line: 212,
          column: 5
        }
      },
      "62": {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 211,
          column: 33
        }
      },
      "63": {
        start: {
          line: 214,
          column: 4
        },
        end: {
          line: 216,
          column: 5
        }
      },
      "64": {
        start: {
          line: 215,
          column: 6
        },
        end: {
          line: 215,
          column: 42
        }
      },
      "65": {
        start: {
          line: 218,
          column: 40
        },
        end: {
          line: 218,
          column: 70
        }
      },
      "66": {
        start: {
          line: 219,
          column: 26
        },
        end: {
          line: 219,
          column: 67
        }
      },
      "67": {
        start: {
          line: 220,
          column: 26
        },
        end: {
          line: 220,
          column: 81
        }
      },
      "68": {
        start: {
          line: 222,
          column: 43
        },
        end: {
          line: 222,
          column: 80
        }
      },
      "69": {
        start: {
          line: 224,
          column: 43
        },
        end: {
          line: 224,
          column: 74
        }
      },
      "70": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 233,
          column: 47
        }
      },
      "71": {
        start: {
          line: 227,
          column: 6
        },
        end: {
          line: 231,
          column: 7
        }
      },
      "72": {
        start: {
          line: 228,
          column: 8
        },
        end: {
          line: 230,
          column: 9
        }
      },
      "73": {
        start: {
          line: 229,
          column: 10
        },
        end: {
          line: 229,
          column: 30
        }
      },
      "74": {
        start: {
          line: 235,
          column: 4
        },
        end: {
          line: 374,
          column: 6
        }
      },
      "75": {
        start: {
          line: 264,
          column: 20
        },
        end: {
          line: 264,
          column: 98
        }
      },
      "76": {
        start: {
          line: 296,
          column: 24
        },
        end: {
          line: 298,
          column: 25
        }
      },
      "77": {
        start: {
          line: 297,
          column: 26
        },
        end: {
          line: 297,
          column: 52
        }
      },
      "78": {
        start: {
          line: 378,
          column: 0
        },
        end: {
          line: 378,
          column: 56
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 84,
            column: 7
          },
          end: {
            line: 375,
            column: 3
          }
        },
        line: 84
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 102,
            column: 6
          },
          end: {
            line: 102,
            column: 7
          }
        },
        loc: {
          start: {
            line: 102,
            column: 26
          },
          end: {
            line: 113,
            column: 7
          }
        },
        line: 102
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 117,
            column: 44
          },
          end: {
            line: 117,
            column: 45
          }
        },
        loc: {
          start: {
            line: 117,
            column: 50
          },
          end: {
            line: 128,
            column: 5
          }
        },
        line: 117
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 130,
            column: 14
          },
          end: {
            line: 130,
            column: 15
          }
        },
        loc: {
          start: {
            line: 130,
            column: 20
          },
          end: {
            line: 135,
            column: 5
          }
        },
        line: 130
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 137,
            column: 35
          },
          end: {
            line: 137,
            column: 36
          }
        },
        loc: {
          start: {
            line: 137,
            column: 49
          },
          end: {
            line: 137,
            column: 95
          }
        },
        line: 137
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 139,
            column: 57
          },
          end: {
            line: 139,
            column: 58
          }
        },
        loc: {
          start: {
            line: 139,
            column: 67
          },
          end: {
            line: 149,
            column: 5
          }
        },
        line: 139
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 151,
            column: 58
          },
          end: {
            line: 151,
            column: 59
          }
        },
        loc: {
          start: {
            line: 151,
            column: 69
          },
          end: {
            line: 156,
            column: 5
          }
        },
        line: 151
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 158,
            column: 61
          },
          end: {
            line: 158,
            column: 62
          }
        },
        loc: {
          start: {
            line: 158,
            column: 75
          },
          end: {
            line: 165,
            column: 5
          }
        },
        line: 158
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 167,
            column: 25
          },
          end: {
            line: 167,
            column: 26
          }
        },
        loc: {
          start: {
            line: 167,
            column: 75
          },
          end: {
            line: 200,
            column: 5
          }
        },
        line: 167
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 226,
            column: 14
          },
          end: {
            line: 226,
            column: 15
          }
        },
        loc: {
          start: {
            line: 226,
            column: 20
          },
          end: {
            line: 233,
            column: 5
          }
        },
        line: 226
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 263,
            column: 26
          },
          end: {
            line: 263,
            column: 27
          }
        },
        loc: {
          start: {
            line: 263,
            column: 32
          },
          end: {
            line: 265,
            column: 19
          }
        },
        line: 263
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 295,
            column: 31
          },
          end: {
            line: 295,
            column: 32
          }
        },
        loc: {
          start: {
            line: 295,
            column: 47
          },
          end: {
            line: 299,
            column: 23
          }
        },
        line: 295
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 66,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 66,
            column: 18
          },
          end: {
            line: 66,
            column: 27
          }
        }],
        line: 66
      },
      "1": {
        loc: {
          start: {
            line: 68,
            column: 6
          },
          end: {
            line: 68,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 22
          },
          end: {
            line: 68,
            column: 31
          }
        }],
        line: 68
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 6
          },
          end: {
            line: 71,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 71,
            column: 19
          },
          end: {
            line: 71,
            column: 37
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 37
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 74,
            column: 33
          },
          end: {
            line: 74,
            column: 37
          }
        }],
        line: 74
      },
      "4": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 75,
            column: 31
          },
          end: {
            line: 75,
            column: 36
          }
        }],
        line: 75
      },
      "5": {
        loc: {
          start: {
            line: 88,
            column: 45
          },
          end: {
            line: 88,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 45
          },
          end: {
            line: 88,
            column: 56
          }
        }, {
          start: {
            line: 88,
            column: 60
          },
          end: {
            line: 88,
            column: 62
          }
        }],
        line: 88
      },
      "6": {
        loc: {
          start: {
            line: 91,
            column: 47
          },
          end: {
            line: 91,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 47
          },
          end: {
            line: 91,
            column: 59
          }
        }, {
          start: {
            line: 91,
            column: 63
          },
          end: {
            line: 91,
            column: 65
          }
        }],
        line: 91
      },
      "7": {
        loc: {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 105,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 105,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 103
      },
      "8": {
        loc: {
          start: {
            line: 103,
            column: 12
          },
          end: {
            line: 103,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 12
          },
          end: {
            line: 103,
            column: 24
          }
        }, {
          start: {
            line: 103,
            column: 28
          },
          end: {
            line: 103,
            column: 40
          }
        }],
        line: 103
      },
      "9": {
        loc: {
          start: {
            line: 120,
            column: 26
          },
          end: {
            line: 120,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 26
          },
          end: {
            line: 120,
            column: 51
          }
        }, {
          start: {
            line: 120,
            column: 55
          },
          end: {
            line: 120,
            column: 67
          }
        }],
        line: 120
      },
      "10": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 127,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 123
      },
      "11": {
        loc: {
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 10
          },
          end: {
            line: 123,
            column: 28
          }
        }, {
          start: {
            line: 123,
            column: 32
          },
          end: {
            line: 123,
            column: 57
          }
        }],
        line: 123
      },
      "12": {
        loc: {
          start: {
            line: 125,
            column: 17
          },
          end: {
            line: 125,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 125,
            column: 28
          },
          end: {
            line: 125,
            column: 30
          }
        }, {
          start: {
            line: 125,
            column: 33
          },
          end: {
            line: 125,
            column: 38
          }
        }],
        line: 125
      },
      "13": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "14": {
        loc: {
          start: {
            line: 137,
            column: 49
          },
          end: {
            line: 137,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 49
          },
          end: {
            line: 137,
            column: 69
          }
        }, {
          start: {
            line: 137,
            column: 73
          },
          end: {
            line: 137,
            column: 95
          }
        }],
        line: 137
      },
      "15": {
        loc: {
          start: {
            line: 141,
            column: 26
          },
          end: {
            line: 141,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 141,
            column: 26
          },
          end: {
            line: 141,
            column: 37
          }
        }, {
          start: {
            line: 141,
            column: 41
          },
          end: {
            line: 141,
            column: 52
          }
        }],
        line: 141
      },
      "16": {
        loc: {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        }, {
          start: {
            line: 146,
            column: 13
          },
          end: {
            line: 148,
            column: 7
          }
        }],
        line: 144
      },
      "17": {
        loc: {
          start: {
            line: 145,
            column: 21
          },
          end: {
            line: 145,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 35
          },
          end: {
            line: 145,
            column: 40
          }
        }, {
          start: {
            line: 145,
            column: 43
          },
          end: {
            line: 145,
            column: 55
          }
        }],
        line: 145
      },
      "18": {
        loc: {
          start: {
            line: 147,
            column: 21
          },
          end: {
            line: 147,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 147,
            column: 21
          },
          end: {
            line: 147,
            column: 32
          }
        }, {
          start: {
            line: 147,
            column: 36
          },
          end: {
            line: 147,
            column: 48
          }
        }],
        line: 147
      },
      "19": {
        loc: {
          start: {
            line: 163,
            column: 18
          },
          end: {
            line: 163,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 18
          },
          end: {
            line: 163,
            column: 33
          }
        }, {
          start: {
            line: 163,
            column: 37
          },
          end: {
            line: 163,
            column: 70
          }
        }],
        line: 163
      },
      "20": {
        loc: {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 170
      },
      "21": {
        loc: {
          start: {
            line: 170,
            column: 10
          },
          end: {
            line: 170,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 170,
            column: 10
          },
          end: {
            line: 170,
            column: 18
          }
        }, {
          start: {
            line: 170,
            column: 23
          },
          end: {
            line: 170,
            column: 33
          }
        }, {
          start: {
            line: 170,
            column: 38
          },
          end: {
            line: 170,
            column: 50
          }
        }, {
          start: {
            line: 170,
            column: 54
          },
          end: {
            line: 170,
            column: 67
          }
        }],
        line: 170
      },
      "22": {
        loc: {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 182,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 182,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 174
      },
      "23": {
        loc: {
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 179,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 176,
            column: 8
          },
          end: {
            line: 176,
            column: 62
          }
        }, {
          start: {
            line: 177,
            column: 8
          },
          end: {
            line: 177,
            column: 32
          }
        }, {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 40
          }
        }, {
          start: {
            line: 179,
            column: 8
          },
          end: {
            line: 179,
            column: 34
          }
        }],
        line: 176
      },
      "24": {
        loc: {
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 193,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 6
          },
          end: {
            line: 193,
            column: 7
          }
        }, {
          start: {
            line: 191,
            column: 13
          },
          end: {
            line: 193,
            column: 7
          }
        }],
        line: 184
      },
      "25": {
        loc: {
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 8
          },
          end: {
            line: 190,
            column: 9
          }
        }, {
          start: {
            line: 187,
            column: 15
          },
          end: {
            line: 190,
            column: 9
          }
        }],
        line: 185
      },
      "26": {
        loc: {
          start: {
            line: 185,
            column: 12
          },
          end: {
            line: 185,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 185,
            column: 12
          },
          end: {
            line: 185,
            column: 47
          }
        }, {
          start: {
            line: 185,
            column: 51
          },
          end: {
            line: 185,
            column: 74
          }
        }],
        line: 185
      },
      "27": {
        loc: {
          start: {
            line: 203,
            column: 6
          },
          end: {
            line: 205,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 6
          },
          end: {
            line: 203,
            column: 14
          }
        }, {
          start: {
            line: 204,
            column: 7
          },
          end: {
            line: 204,
            column: 25
          }
        }, {
          start: {
            line: 204,
            column: 30
          },
          end: {
            line: 204,
            column: 39
          }
        }, {
          start: {
            line: 204,
            column: 43
          },
          end: {
            line: 204,
            column: 64
          }
        }, {
          start: {
            line: 205,
            column: 7
          },
          end: {
            line: 205,
            column: 17
          }
        }, {
          start: {
            line: 205,
            column: 23
          },
          end: {
            line: 205,
            column: 40
          }
        }, {
          start: {
            line: 205,
            column: 45
          },
          end: {
            line: 205,
            column: 50
          }
        }, {
          start: {
            line: 205,
            column: 54
          },
          end: {
            line: 205,
            column: 66
          }
        }, {
          start: {
            line: 205,
            column: 72
          },
          end: {
            line: 205,
            column: 85
          }
        }],
        line: 203
      },
      "28": {
        loc: {
          start: {
            line: 208,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 208,
            column: 4
          },
          end: {
            line: 212,
            column: 5
          }
        }, {
          start: {
            line: 210,
            column: 11
          },
          end: {
            line: 212,
            column: 5
          }
        }],
        line: 208
      },
      "29": {
        loc: {
          start: {
            line: 210,
            column: 11
          },
          end: {
            line: 212,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 210,
            column: 11
          },
          end: {
            line: 212,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 210
      },
      "30": {
        loc: {
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 216,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 214,
            column: 4
          },
          end: {
            line: 216,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 214
      },
      "31": {
        loc: {
          start: {
            line: 218,
            column: 40
          },
          end: {
            line: 218,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 40
          },
          end: {
            line: 218,
            column: 56
          }
        }, {
          start: {
            line: 218,
            column: 60
          },
          end: {
            line: 218,
            column: 70
          }
        }],
        line: 218
      },
      "32": {
        loc: {
          start: {
            line: 219,
            column: 26
          },
          end: {
            line: 219,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 219,
            column: 26
          },
          end: {
            line: 219,
            column: 53
          }
        }, {
          start: {
            line: 219,
            column: 57
          },
          end: {
            line: 219,
            column: 67
          }
        }],
        line: 219
      },
      "33": {
        loc: {
          start: {
            line: 220,
            column: 26
          },
          end: {
            line: 220,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 220,
            column: 39
          },
          end: {
            line: 220,
            column: 49
          }
        }, {
          start: {
            line: 220,
            column: 52
          },
          end: {
            line: 220,
            column: 81
          }
        }],
        line: 220
      },
      "34": {
        loc: {
          start: {
            line: 222,
            column: 43
          },
          end: {
            line: 222,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 43
          },
          end: {
            line: 222,
            column: 66
          }
        }, {
          start: {
            line: 222,
            column: 70
          },
          end: {
            line: 222,
            column: 80
          }
        }],
        line: 222
      },
      "35": {
        loc: {
          start: {
            line: 227,
            column: 6
          },
          end: {
            line: 231,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 227,
            column: 6
          },
          end: {
            line: 231,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 227
      },
      "36": {
        loc: {
          start: {
            line: 227,
            column: 10
          },
          end: {
            line: 227,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 10
          },
          end: {
            line: 227,
            column: 27
          }
        }, {
          start: {
            line: 227,
            column: 31
          },
          end: {
            line: 227,
            column: 48
          }
        }],
        line: 227
      },
      "37": {
        loc: {
          start: {
            line: 228,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 228,
            column: 8
          },
          end: {
            line: 230,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 228
      },
      "38": {
        loc: {
          start: {
            line: 228,
            column: 12
          },
          end: {
            line: 228,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 12
          },
          end: {
            line: 228,
            column: 15
          }
        }, {
          start: {
            line: 228,
            column: 19
          },
          end: {
            line: 228,
            column: 35
          }
        }, {
          start: {
            line: 228,
            column: 39
          },
          end: {
            line: 228,
            column: 50
          }
        }],
        line: 228
      },
      "39": {
        loc: {
          start: {
            line: 240,
            column: 15
          },
          end: {
            line: 255,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 240,
            column: 15
          },
          end: {
            line: 240,
            column: 25
          }
        }, {
          start: {
            line: 240,
            column: 29
          },
          end: {
            line: 240,
            column: 44
          }
        }, {
          start: {
            line: 241,
            column: 16
          },
          end: {
            line: 254,
            column: 18
          }
        }],
        line: 240
      },
      "40": {
        loc: {
          start: {
            line: 246,
            column: 29
          },
          end: {
            line: 246,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 246,
            column: 44
          },
          end: {
            line: 246,
            column: 67
          }
        }, {
          start: {
            line: 246,
            column: 70
          },
          end: {
            line: 246,
            column: 79
          }
        }],
        line: 246
      },
      "41": {
        loc: {
          start: {
            line: 248,
            column: 25
          },
          end: {
            line: 248,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 248,
            column: 41
          },
          end: {
            line: 248,
            column: 54
          }
        }, {
          start: {
            line: 248,
            column: 57
          },
          end: {
            line: 248,
            column: 70
          }
        }],
        line: 248
      },
      "42": {
        loc: {
          start: {
            line: 250,
            column: 31
          },
          end: {
            line: 250,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 250,
            column: 53
          },
          end: {
            line: 250,
            column: 72
          }
        }, {
          start: {
            line: 250,
            column: 75
          },
          end: {
            line: 250,
            column: 77
          }
        }],
        line: 250
      },
      "43": {
        loc: {
          start: {
            line: 256,
            column: 15
          },
          end: {
            line: 275,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 256,
            column: 15
          },
          end: {
            line: 256,
            column: 33
          }
        }, {
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 274,
            column: 18
          }
        }],
        line: 256
      },
      "44": {
        loc: {
          start: {
            line: 262,
            column: 29
          },
          end: {
            line: 262,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 262,
            column: 29
          },
          end: {
            line: 262,
            column: 46
          }
        }, {
          start: {
            line: 262,
            column: 50
          },
          end: {
            line: 262,
            column: 67
          }
        }],
        line: 262
      },
      "45": {
        loc: {
          start: {
            line: 264,
            column: 40
          },
          end: {
            line: 264,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 264,
            column: 40
          },
          end: {
            line: 264,
            column: 59
          }
        }, {
          start: {
            line: 264,
            column: 63
          },
          end: {
            line: 264,
            column: 96
          }
        }],
        line: 264
      },
      "46": {
        loc: {
          start: {
            line: 276,
            column: 15
          },
          end: {
            line: 304,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 276,
            column: 15
          },
          end: {
            line: 276,
            column: 25
          }
        }, {
          start: {
            line: 276,
            column: 29
          },
          end: {
            line: 276,
            column: 52
          }
        }, {
          start: {
            line: 277,
            column: 16
          },
          end: {
            line: 303,
            column: 22
          }
        }],
        line: 276
      },
      "47": {
        loc: {
          start: {
            line: 289,
            column: 19
          },
          end: {
            line: 302,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 289,
            column: 19
          },
          end: {
            line: 289,
            column: 64
          }
        }, {
          start: {
            line: 290,
            column: 20
          },
          end: {
            line: 301,
            column: 22
          }
        }],
        line: 289
      },
      "48": {
        loc: {
          start: {
            line: 296,
            column: 24
          },
          end: {
            line: 298,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 296,
            column: 24
          },
          end: {
            line: 298,
            column: 25
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 296
      },
      "49": {
        loc: {
          start: {
            line: 307,
            column: 18
          },
          end: {
            line: 307,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 307,
            column: 51
          },
          end: {
            line: 307,
            column: 56
          }
        }, {
          start: {
            line: 307,
            column: 59
          },
          end: {
            line: 307,
            column: 64
          }
        }],
        line: 307
      },
      "50": {
        loc: {
          start: {
            line: 309,
            column: 30
          },
          end: {
            line: 309,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 309,
            column: 63
          },
          end: {
            line: 309,
            column: 69
          }
        }, {
          start: {
            line: 309,
            column: 72
          },
          end: {
            line: 309,
            column: 76
          }
        }],
        line: 309
      },
      "51": {
        loc: {
          start: {
            line: 312,
            column: 30
          },
          end: {
            line: 312,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 312,
            column: 63
          },
          end: {
            line: 312,
            column: 68
          }
        }, {
          start: {
            line: 312,
            column: 71
          },
          end: {
            line: 312,
            column: 75
          }
        }],
        line: 312
      },
      "52": {
        loc: {
          start: {
            line: 315,
            column: 15
          },
          end: {
            line: 317,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 315,
            column: 15
          },
          end: {
            line: 315,
            column: 45
          }
        }, {
          start: {
            line: 316,
            column: 16
          },
          end: {
            line: 316,
            column: 69
          }
        }],
        line: 315
      },
      "53": {
        loc: {
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 356,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 332,
            column: 9
          },
          end: {
            line: 332,
            column: 30
          }
        }, {
          start: {
            line: 333,
            column: 10
          },
          end: {
            line: 355,
            column: 16
          }
        }],
        line: 332
      },
      "54": {
        loc: {
          start: {
            line: 357,
            column: 9
          },
          end: {
            line: 372,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 357,
            column: 9
          },
          end: {
            line: 357,
            column: 39
          }
        }, {
          start: {
            line: 358,
            column: 10
          },
          end: {
            line: 371,
            column: 23
          }
        }],
        line: 357
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0, 0],
      "22": [0, 0],
      "23": [0, 0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0, 0, 0, 0, 0, 0, 0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0, 0],
      "39": [0, 0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9807a44693d66588362b0ed9f763b4b2a7a2dcc8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2cjzfzrvji = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2cjzfzrvji();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import React, { forwardRef, useCallback, useContext, useEffect, useState } from 'react';
import { Box, Button, Link, SimpleCheckbox, Text, TextInput, ValidatedTextInput } from '@opendoor/bricks-next';
// Note: checkTelValidity has been replaced with ValidatedTextInput's built-in validation

import { NamelessAccountContext } from "../../growth/auth/NamelessAccountContext.mjs";
import { t } from "../../i18n/translationHelper.mjs";
import AccountFormControls from "./AccountFormControls.mjs";
import { Disclaimer, EmailDisclaimerText, Form } from "./shared.mjs";
var AccountPasswordForm = (cov_2cjzfzrvji().s[0]++, /*#__PURE__*/forwardRef(function (_ref, ref) {
  var initialName = _ref.name,
    initialPhone = _ref.phone,
    onRegister = _ref.onRegister,
    onLogin = _ref.onLogin,
    hidePasswordField = _ref.hidePasswordField,
    isNewHuman = _ref.isNewHuman,
    onboardingAccountPageCTA = _ref.onboardingAccountPageCTA,
    passwordFormActionText = _ref.passwordFormActionText,
    _ref$NameInput = _ref.NameInput,
    NameInput = _ref$NameInput === void 0 ? (cov_2cjzfzrvji().b[0][0]++, TextInput) : _ref$NameInput,
    analyticsName = _ref.analyticsName,
    _ref$PasswordInput = _ref.PasswordInput,
    PasswordInput = _ref$PasswordInput === void 0 ? (cov_2cjzfzrvji().b[1][0]++, TextInput) : _ref$PasswordInput,
    fullNameLabel = _ref.fullNameLabel,
    fullNamePlaceholder = _ref.fullNamePlaceholder,
    _ref$PhoneInput = _ref.PhoneInput,
    PhoneInput = _ref$PhoneInput === void 0 ? (cov_2cjzfzrvji().b[2][0]++, ValidatedTextInput) : _ref$PhoneInput,
    loading = _ref.loading,
    loginError = _ref.loginError,
    _ref$phoneNumberInput = _ref.phoneNumberInputOptional,
    phoneNumberInputOptional = _ref$phoneNumberInput === void 0 ? (cov_2cjzfzrvji().b[3][0]++, true) : _ref$phoneNumberInput,
    _ref$phoneNumberInput2 = _ref.phoneNumberInputHidden,
    phoneNumberInputHidden = _ref$phoneNumberInput2 === void 0 ? (cov_2cjzfzrvji().b[4][0]++, false) : _ref$phoneNumberInput2,
    showPasswordlessLogin = _ref.showPasswordlessLogin,
    onRequestPasswordlessLogin = _ref.onRequestPasswordlessLogin,
    isRequestingPasswordlessLogin = _ref.isRequestingPasswordlessLogin,
    openForgotPasswordInNewTab = _ref.openForgotPasswordInNewTab,
    fullNameOptional = _ref.fullNameOptional,
    fullNameHidden = _ref.fullNameHidden;
  cov_2cjzfzrvji().f[0]++;
  var context = (cov_2cjzfzrvji().s[1]++, useContext(NamelessAccountContext));
  var _ref2 = (cov_2cjzfzrvji().s[2]++, useState(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    hasError = _ref3[0],
    setHasError = _ref3[1];
  var _ref4 = (cov_2cjzfzrvji().s[3]++, useState((cov_2cjzfzrvji().b[5][0]++, initialName) || (cov_2cjzfzrvji().b[5][1]++, ''))),
    _ref5 = _slicedToArray(_ref4, 2),
    name = _ref5[0],
    setName = _ref5[1];
  var _ref6 = (cov_2cjzfzrvji().s[4]++, useState(false)),
    _ref7 = _slicedToArray(_ref6, 2),
    hasNameError = _ref7[0],
    setNameError = _ref7[1];
  var _ref8 = (cov_2cjzfzrvji().s[5]++, useState(false)),
    _ref9 = _slicedToArray(_ref8, 2),
    hasPasswordError = _ref9[0],
    setHasPasswordError = _ref9[1];
  var _ref10 = (cov_2cjzfzrvji().s[6]++, useState((cov_2cjzfzrvji().b[6][0]++, initialPhone) || (cov_2cjzfzrvji().b[6][1]++, ''))),
    _ref11 = _slicedToArray(_ref10, 2),
    phone = _ref11[0],
    setPhone = _ref11[1];
  var _ref12 = (cov_2cjzfzrvji().s[7]++, useState(false)),
    _ref13 = _slicedToArray(_ref12, 2),
    smsSubscribed = _ref13[0],
    setSmsSubscribed = _ref13[1];
  var _ref14 = (cov_2cjzfzrvji().s[8]++, useState(!phoneNumberInputOptional)),
    _ref15 = _slicedToArray(_ref14, 2),
    hasPhoneError = _ref15[0],
    setPhoneError = _ref15[1];
  var _ref16 = (cov_2cjzfzrvji().s[9]++, useState('')),
    _ref17 = _slicedToArray(_ref16, 2),
    password = _ref17[0],
    setPassword = _ref17[1];
  var _ref18 = (cov_2cjzfzrvji().s[10]++, useState({})),
    _ref19 = _slicedToArray(_ref18, 2),
    lastSubmit = _ref19[0],
    setLastSubmit = _ref19[1];
  var getPhoneState = (cov_2cjzfzrvji().s[11]++, useCallback(function (phone) {
    cov_2cjzfzrvji().f[1]++;
    cov_2cjzfzrvji().s[12]++;
    if ((cov_2cjzfzrvji().b[8][0]++, _isNil(phone)) || (cov_2cjzfzrvji().b[8][1]++, phone === '')) {
      cov_2cjzfzrvji().b[7][0]++;
      cov_2cjzfzrvji().s[13]++;
      return {
        hasError: !phoneNumberInputOptional,
        value: phone
      };
    } else {
      cov_2cjzfzrvji().b[7][1]++;
    }

    // ValidatedTextInput with format="telephoneNumber" will handle phone validation
    // This is just for initial state - actual validation happens in the component
    cov_2cjzfzrvji().s[14]++;
    return {
      hasError: false,
      // Let ValidatedTextInput handle validation
      value: phone
    };
  }, [phoneNumberInputOptional]));
  var maybePrefillAccount = (cov_2cjzfzrvji().s[15]++, useCallback(function () {
    cov_2cjzfzrvji().f[2]++;
    var url = (cov_2cjzfzrvji().s[16]++, new URL(window.location.href));
    var params = (cov_2cjzfzrvji().s[17]++, new URLSearchParams(url.searchParams));
    var phoneNumber = (cov_2cjzfzrvji().s[18]++, (cov_2cjzfzrvji().b[9][0]++, params.get('phoneNumber')) || (cov_2cjzfzrvji().b[9][1]++, initialPhone));
    var _ref20 = (cov_2cjzfzrvji().s[19]++, getPhoneState(phoneNumber)),
      value = _ref20.value,
      hasError = _ref20.hasError;
    cov_2cjzfzrvji().s[20]++;
    if ((cov_2cjzfzrvji().b[11][0]++, params.get('name')) || (cov_2cjzfzrvji().b[11][1]++, params.get('phoneNumber'))) {
      cov_2cjzfzrvji().b[10][0]++;
      cov_2cjzfzrvji().s[21]++;
      setName(params.get('name'));
      cov_2cjzfzrvji().s[22]++;
      setPhone(hasError ? (cov_2cjzfzrvji().b[12][0]++, '') : (cov_2cjzfzrvji().b[12][1]++, value));
      cov_2cjzfzrvji().s[23]++;
      setPhoneError(hasError);
    } else {
      cov_2cjzfzrvji().b[10][1]++;
    }
  }, [getPhoneState, initialPhone]));
  cov_2cjzfzrvji().s[24]++;
  useEffect(function () {
    cov_2cjzfzrvji().f[3]++;
    cov_2cjzfzrvji().s[25]++;
    maybePrefillAccount();
    cov_2cjzfzrvji().s[26]++;
    if (context.onPasswordFormLoad) {
      cov_2cjzfzrvji().b[13][0]++;
      cov_2cjzfzrvji().s[27]++;
      context.onPasswordFormLoad();
    } else {
      cov_2cjzfzrvji().b[13][1]++;
    }
  }, [context, maybePrefillAccount]);
  cov_2cjzfzrvji().s[28]++;
  var validatePasswordLength = function validatePasswordLength(password) {
    cov_2cjzfzrvji().f[4]++;
    cov_2cjzfzrvji().s[29]++;
    return (cov_2cjzfzrvji().b[14][0]++, password.length >= 5) && (cov_2cjzfzrvji().b[14][1]++, password.length <= 128);
  };
  cov_2cjzfzrvji().s[30]++;
  var onNameChange = function onNameChange(name) {
    cov_2cjzfzrvji().f[5]++;
    cov_2cjzfzrvji().s[31]++;
    setName(name);
    var isNameEmpty = (cov_2cjzfzrvji().s[32]++, (cov_2cjzfzrvji().b[15][0]++, _isNil(name)) || (cov_2cjzfzrvji().b[15][1]++, name === ''));
    var isNameValid = (cov_2cjzfzrvji().s[33]++, name.trim() !== '');
    cov_2cjzfzrvji().s[34]++;
    if (fullNameOptional) {
      cov_2cjzfzrvji().b[16][0]++;
      cov_2cjzfzrvji().s[35]++;
      setNameError(isNameEmpty ? (cov_2cjzfzrvji().b[17][0]++, false) : (cov_2cjzfzrvji().b[17][1]++, !isNameValid));
    } else {
      cov_2cjzfzrvji().b[16][1]++;
      cov_2cjzfzrvji().s[36]++;
      setNameError((cov_2cjzfzrvji().b[18][0]++, isNameEmpty) || (cov_2cjzfzrvji().b[18][1]++, !isNameValid));
    }
  };
  cov_2cjzfzrvji().s[37]++;
  var onPhoneChange = function onPhoneChange(phone) {
    cov_2cjzfzrvji().f[6]++;
    var _ref21 = (cov_2cjzfzrvji().s[38]++, getPhoneState(phone)),
      value = _ref21.value,
      hasError = _ref21.hasError;
    cov_2cjzfzrvji().s[39]++;
    setPhone(value);
    cov_2cjzfzrvji().s[40]++;
    setPhoneError(hasError);
  };
  cov_2cjzfzrvji().s[41]++;
  var onPasswordChange = function onPasswordChange(password) {
    cov_2cjzfzrvji().f[7]++;
    cov_2cjzfzrvji().s[42]++;
    //Password is validated only on blur
    setHasPasswordError(false);

    //This is to disable submit based on onchange validation
    cov_2cjzfzrvji().s[43]++;
    setHasError((cov_2cjzfzrvji().b[19][0]++, _isNil(password)) || (cov_2cjzfzrvji().b[19][1]++, !validatePasswordLength(password)));
    cov_2cjzfzrvji().s[44]++;
    setPassword(password);
  };
  cov_2cjzfzrvji().s[45]++;
  var handleSubmit = function handleSubmit(e) {
    cov_2cjzfzrvji().f[8]++;
    cov_2cjzfzrvji().s[46]++;
    e.preventDefault();
    cov_2cjzfzrvji().s[47]++;
    if ((cov_2cjzfzrvji().b[21][0]++, hasError) || (cov_2cjzfzrvji().b[21][1]++, isNewHuman) && ((cov_2cjzfzrvji().b[21][2]++, hasNameError) || (cov_2cjzfzrvji().b[21][3]++, hasPhoneError))) {
      cov_2cjzfzrvji().b[20][0]++;
      cov_2cjzfzrvji().s[48]++;
      return;
    } else {
      cov_2cjzfzrvji().b[20][1]++;
    }
    cov_2cjzfzrvji().s[49]++;
    if (
    // Only check to return early if there is a previous submission
    (cov_2cjzfzrvji().b[23][0]++, Object.values(lastSubmit).filter(Boolean).length !== 0) && (cov_2cjzfzrvji().b[23][1]++, name === lastSubmit.name) && (cov_2cjzfzrvji().b[23][2]++, password === lastSubmit.password) && (cov_2cjzfzrvji().b[23][3]++, phone === lastSubmit.phone)) {
      cov_2cjzfzrvji().b[22][0]++;
      cov_2cjzfzrvji().s[50]++;
      return;
    } else {
      cov_2cjzfzrvji().b[22][1]++;
    }
    cov_2cjzfzrvji().s[51]++;
    if (isNewHuman) {
      cov_2cjzfzrvji().b[24][0]++;
      cov_2cjzfzrvji().s[52]++;
      if ((cov_2cjzfzrvji().b[26][0]++, context.shouldRegisterOnEmailSubmit) && (cov_2cjzfzrvji().b[26][1]++, context.onAccountUpdate)) {
        cov_2cjzfzrvji().b[25][0]++;
        cov_2cjzfzrvji().s[53]++;
        context.onAccountUpdate(name, phone, smsSubscribed);
      } else {
        cov_2cjzfzrvji().b[25][1]++;
        cov_2cjzfzrvji().s[54]++;
        // Registering on pw page does not support SMS opt-out
        onRegister(password, name, phone);
      }
    } else {
      cov_2cjzfzrvji().b[24][1]++;
      cov_2cjzfzrvji().s[55]++;
      onLogin(password);
    }
    cov_2cjzfzrvji().s[56]++;
    setLastSubmit({
      name: name,
      password: password,
      phone: phone
    });
  };
  var shouldDisableSubmit = (cov_2cjzfzrvji().s[57]++, (cov_2cjzfzrvji().b[27][0]++, hasError) || (cov_2cjzfzrvji().b[27][1]++, !hidePasswordField) && ((cov_2cjzfzrvji().b[27][2]++, !password) || (cov_2cjzfzrvji().b[27][3]++, password.length === 0)) || (cov_2cjzfzrvji().b[27][4]++, isNewHuman) && ((cov_2cjzfzrvji().b[27][5]++, !fullNameOptional) && ((cov_2cjzfzrvji().b[27][6]++, !name) || (cov_2cjzfzrvji().b[27][7]++, hasNameError)) || (cov_2cjzfzrvji().b[27][8]++, hasPhoneError)));
  var actionText = (cov_2cjzfzrvji().s[58]++, t('confirm'));
  cov_2cjzfzrvji().s[59]++;
  if (phoneNumberInputHidden) {
    cov_2cjzfzrvji().b[28][0]++;
    cov_2cjzfzrvji().s[60]++;
    actionText = t('next');
  } else {
    cov_2cjzfzrvji().b[28][1]++;
    cov_2cjzfzrvji().s[61]++;
    if (onboardingAccountPageCTA) {
      cov_2cjzfzrvji().b[29][0]++;
      cov_2cjzfzrvji().s[62]++;
      actionText = t('continue');
    } else {
      cov_2cjzfzrvji().b[29][1]++;
    }
  }
  cov_2cjzfzrvji().s[63]++;
  if (passwordFormActionText) {
    cov_2cjzfzrvji().b[30][0]++;
    cov_2cjzfzrvji().s[64]++;
    actionText = passwordFormActionText;
  } else {
    cov_2cjzfzrvji().b[30][1]++;
  }
  var hasPasswordRequirementError = (cov_2cjzfzrvji().s[65]++, (cov_2cjzfzrvji().b[31][0]++, hasPasswordError) && (cov_2cjzfzrvji().b[31][1]++, isNewHuman)),
    showPasswordError = (cov_2cjzfzrvji().s[66]++, (cov_2cjzfzrvji().b[32][0]++, hasPasswordRequirementError) || (cov_2cjzfzrvji().b[32][1]++, loginError)),
    passwordErrorText = (cov_2cjzfzrvji().s[67]++, loginError ? (cov_2cjzfzrvji().b[33][0]++, loginError) : (cov_2cjzfzrvji().b[33][1]++, t('passwordRequirementError')));
  var shouldRenderDisclaimerAboveCTA = (cov_2cjzfzrvji().s[68]++, (cov_2cjzfzrvji().b[34][0]++, !phoneNumberInputHidden) && (cov_2cjzfzrvji().b[34][1]++, isNewHuman));
  var shouldRenderDisclaimerBelowCTA = (cov_2cjzfzrvji().s[69]++, !shouldRenderDisclaimerAboveCTA);
  cov_2cjzfzrvji().s[70]++;
  useEffect(function () {
    cov_2cjzfzrvji().f[9]++;
    cov_2cjzfzrvji().s[71]++;
    if ((cov_2cjzfzrvji().b[36][0]++, showPasswordError) && (cov_2cjzfzrvji().b[36][1]++, passwordErrorText)) {
      cov_2cjzfzrvji().b[35][0]++;
      cov_2cjzfzrvji().s[72]++;
      if ((cov_2cjzfzrvji().b[38][0]++, ref) && (cov_2cjzfzrvji().b[38][1]++, 'current' in ref) && (cov_2cjzfzrvji().b[38][2]++, ref.current)) {
        cov_2cjzfzrvji().b[37][0]++;
        cov_2cjzfzrvji().s[73]++;
        ref.current.focus();
      } else {
        cov_2cjzfzrvji().b[37][1]++;
      }
    } else {
      cov_2cjzfzrvji().b[35][1]++;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPasswordError, passwordErrorText]);
  cov_2cjzfzrvji().s[74]++;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Form, {
    onSubmitCapture: handleSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    marginBottom: "$20x"
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "$20x"
  }, (cov_2cjzfzrvji().b[39][0]++, isNewHuman) && (cov_2cjzfzrvji().b[39][1]++, !fullNameHidden) && (cov_2cjzfzrvji().b[39][2]++, /*#__PURE__*/React.createElement(NameInput, {
    analyticsName: "".concat(analyticsName, "-name"),
    autoComplete: "name"
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: true,
    errorText: hasNameError ? (cov_2cjzfzrvji().b[40][0]++, t('enterFullNameError')) : (cov_2cjzfzrvji().b[40][1]++, undefined),
    id: "name",
    title: fullNameLabel ? (cov_2cjzfzrvji().b[41][0]++, fullNameLabel) : (cov_2cjzfzrvji().b[41][1]++, t('fullName')),
    onChangeText: onNameChange,
    placeholder: fullNamePlaceholder ? (cov_2cjzfzrvji().b[42][0]++, fullNamePlaceholder) : (cov_2cjzfzrvji().b[42][1]++, ''),
    required: !fullNameOptional,
    prefilledValue: name,
    size: "medium"
  })), (cov_2cjzfzrvji().b[43][0]++, !hidePasswordField) && (cov_2cjzfzrvji().b[43][1]++, /*#__PURE__*/React.createElement(PasswordInput, {
    analyticsName: "".concat(analyticsName, "-password")
    // eslint-disable-next-line jsx-a11y/no-autofocus
    ,
    autoFocus: !isNewHuman,
    supportText: t('passwordSupportText'),
    errorText: (cov_2cjzfzrvji().b[44][0]++, showPasswordError) && (cov_2cjzfzrvji().b[44][1]++, passwordErrorText),
    onBlur: function onBlur() {
      cov_2cjzfzrvji().f[10]++;
      cov_2cjzfzrvji().s[75]++;
      setHasPasswordError((cov_2cjzfzrvji().b[45][0]++, password.length > 0) && (cov_2cjzfzrvji().b[45][1]++, !validatePasswordLength(password)));
    },
    id: "password",
    title: t('password'),
    size: "medium",
    ref: ref,
    onChangeText: onPasswordChange,
    required: true,
    textContentType: "password",
    prefilledValue: password
  })), (cov_2cjzfzrvji().b[46][0]++, isNewHuman) && (cov_2cjzfzrvji().b[46][1]++, !phoneNumberInputHidden) && (cov_2cjzfzrvji().b[46][2]++, /*#__PURE__*/React.createElement(Box, {
    gap: "$5x"
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    analyticsName: "".concat(analyticsName, "-phone"),
    id: "phone",
    title: t('phoneNumber'),
    onChangeText: onPhoneChange,
    required: !phoneNumberInputOptional,
    size: "medium",
    placeholder: "000-000-0000",
    format: "telephoneNumber",
    prefilledValue: phone
  }), (cov_2cjzfzrvji().b[47][0]++, analyticsName === 'reception-fe-account-form') && (cov_2cjzfzrvji().b[47][1]++, /*#__PURE__*/React.createElement(SimpleCheckbox, {
    size: "xsmall",
    label: t('smsOptIn'),
    value: "value",
    analyticsName: "".concat(analyticsName, "-sms-checkbox"),
    onPress: function onPress(_, checked) {
      cov_2cjzfzrvji().f[11]++;
      cov_2cjzfzrvji().s[76]++;
      if (typeof checked === 'boolean') {
        cov_2cjzfzrvji().b[48][0]++;
        cov_2cjzfzrvji().s[77]++;
        setSmsSubscribed(checked);
      } else {
        cov_2cjzfzrvji().b[48][1]++;
      }
    },
    name: "marketing-opt-in"
  }))))), /*#__PURE__*/React.createElement(Box, {
    mt: shouldRenderDisclaimerAboveCTA ? (cov_2cjzfzrvji().b[49][0]++, '$0x') : (cov_2cjzfzrvji().b[49][1]++, '$4x'),
    $largerThanSM: {
      marginBottom: shouldRenderDisclaimerAboveCTA ? (cov_2cjzfzrvji().b[50][0]++, '$10x') : (cov_2cjzfzrvji().b[50][1]++, null)
    },
    $smallerThanMD: {
      marginBottom: shouldRenderDisclaimerAboveCTA ? (cov_2cjzfzrvji().b[51][0]++, '$5x') : (cov_2cjzfzrvji().b[51][1]++, null)
    }
  }, (cov_2cjzfzrvji().b[52][0]++, shouldRenderDisclaimerAboveCTA) && (cov_2cjzfzrvji().b[52][1]++, /*#__PURE__*/React.createElement(EmailDisclaimerText, {
    analyticsName: analyticsName
  }))), /*#__PURE__*/React.createElement(AccountFormControls, {
    actionText: actionText,
    analyticsName: analyticsName,
    loading: loading,
    showForgotPassword: !isNewHuman,
    onRequestPasswordlessLogin: onRequestPasswordlessLogin,
    isRequestingPasswordlessLogin: isRequestingPasswordlessLogin,
    disabled: shouldDisableSubmit,
    submitA11yProps: {
      'aria-label': ''
    },
    openForgotPasswordInNewTab: openForgotPasswordInNewTab
  }))), (cov_2cjzfzrvji().b[53][0]++, showPasswordlessLogin) && (cov_2cjzfzrvji().b[53][1]++, /*#__PURE__*/React.createElement(Box, {
    "data-testid": "passwordless-login",
    paddingTop: "$20x",
    marginBottom: "$20x",
    borderTopWidth: 1,
    borderTopColor: "$borderPrimary"
  }, /*#__PURE__*/React.createElement(Text, {
    typography: "$subheaderSmall",
    tag: "h3",
    paddingBottom: "$10x",
    textAlign: "left"
  }, t('passwordlessHeader')), /*#__PURE__*/React.createElement(Text, {
    typography: "$bodySmall",
    tag: "h3",
    textAlign: "left",
    paddingBottom: "$20x"
  }, t('passwordlessDescription')), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    loading: isRequestingPasswordlessLogin,
    analyticsName: "".concat(analyticsName, "-email-login-link"),
    "aria-label": null,
    onPress: onRequestPasswordlessLogin,
    size: "medium",
    label: "Email login link"
  }))), (cov_2cjzfzrvji().b[54][0]++, shouldRenderDisclaimerBelowCTA) && (cov_2cjzfzrvji().b[54][1]++, /*#__PURE__*/React.createElement(Disclaimer, {
    mt: 5
  }, t('emailDisclaimerPrefix'), "\xA0", /*#__PURE__*/React.createElement(Link, {
    href: "https://www.opendoor.com/w/privacy",
    target: "_blank",
    analyticsName: "".concat(analyticsName, "-privacy-policy"),
    "aria-label": t('privacyPolicyAria'),
    typography: "$bodyXsmall"
  }, t('privacyPolicy')), ".", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null))));
}));
cov_2cjzfzrvji().s[78]++;
AccountPasswordForm.displayName = 'AccountPasswordForm';
export default AccountPasswordForm;
//# sourceMappingURL=AccountPasswordForm.mjs.map